export default {"src":"/_next/static/media/cardano_logo_full.4970e67c.svg","height":251,"width":1250,"blurWidth":0,"blurHeight":0};